import { gate as v3GateWrapper } from 'hub-http/gates';

// This function ensures that we can pass v3 gates in the url using ?gated/?ungated without
// having to manually prefix them with "g8:".
// This does not allow users to *check* v3 gates dynamically — the checks in their code
// must still follow the rules to work with the gates in the actual auth response.
function addV3Compat(gates) {
  // eslint-disable-next-line hubspot-dev/no-bare-gate-strings
  return gates.flatMap(gate => [gate, v3GateWrapper(gate)]);
}

// Applies the ?gated/?ungated query params to the list of gates.
// Used to allow users to dynamically enable/disable gates via the url.
export function applyQueryParamOverrides(gates, queryParams) {
  if (!queryParams.has('gated') && !queryParams.has('ungated')) {
    return gates;
  }
  const positive = addV3Compat(queryParams.getAll('ungated'));
  const negative = new Set(addV3Compat(queryParams.getAll('gated')));
  return [...gates, ...positive].filter(gate => !negative.has(gate));
}